import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <div>
    <footer
      className="text-center font-small pt-4"
      style={{
        backgroundColor: "#343A40",
        color: "#FFFFFF",
        padding: "30px 0",
        marginTop: "40px",
      }}
    >
      {/* Верхний блок кнопок */}
      <div className="container pb-3">
        <Link
          className="btn btn-outline-light btn-md m-2"
          to="/contact"
          role="button"
          style={{ fontSize: "0.9rem", padding: "10px 20px" }}
        >
          Contact Us <i className="fa fa-send ml-2" />
        </Link>
        <Link
          className="btn btn-outline-light btn-md m-2"
          to="/about"
          role="button"
          style={{ fontSize: "0.9rem", padding: "10px 20px" }}
        >
          About Us <i className="fa fa-info-circle ml-2" />
        </Link>
        <Link
          className="btn btn-outline-light btn-md m-2"
          to="/technology"
          role="button"
          style={{ fontSize: "0.9rem", padding: "10px 20px" }}
        >
          Our Technology <i className="fa fa-laptop-code ml-2" />
        </Link>
      </div>

      {/* Социальные ссылки */}
      <div className="pb-3">
        <a href="/" className="text-light mx-3">
          <i className="fa fa-facebook-f fa-lg" />
        </a>
        <a href="/" className="text-light mx-3">
          <i className="fa fa-twitter fa-lg" />
        </a>
        <a href="/" className="text-light mx-3">
          <i className="fa fa-youtube fa-lg" />
        </a>
        <a href="/" className="text-light mx-3">
          <i className="fa fa-instagram fa-lg" />
        </a>
      </div>

      {/* Авторское право */}
      <div
        className="py-3 mt-3"
        style={{
          fontSize: "0.85rem",
          backgroundColor: "#23272B",
          color: "#B0B3B5",
        }}
      >
        © 2024 myCCWTT. All Rights Reserved.
      </div>
    </footer>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js